// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsShortMessageDetail__complaint":"jy_a bhb_rg"};